import { render, staticRenderFns } from "./card-tick.vue?vue&type=template&id=7249fb3a&"
import script from "./card-tick.vue?vue&type=script&lang=js&"
export * from "./card-tick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7249fb3a')) {
      api.createRecord('7249fb3a', component.options)
    } else {
      api.reload('7249fb3a', component.options)
    }
    module.hot.accept("./card-tick.vue?vue&type=template&id=7249fb3a&", function () {
      api.rerender('7249fb3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/card-tick.vue"
export default component.exports